// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__4TXNT","close":"modal_close__7LZ4G","title":"modal_title__+K4Dm"};